/* eslint-disable */
import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default props => {
  return (
    <SvgIcon {...props}>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="home"
          transform="translate(-326.000000, -737.000000)"
          stroke="currentColor"
        >
          <g
            id="iPhone-X/Bars/Tab-Bar/5-Items"
            transform="translate(0.000000, 722.000000)"
          >
            <g id="Item-5" transform="translate(313.000000, 9.000000)">
              <g id="Icon">
                <g id="Group-33" transform="translate(14.000000, 7.000000)">
                  <path
                    d="M7.91666667,12.0833333 C7.91666667,13.0041667 7.17083333,13.75 6.25,13.75 C5.32916667,13.75 4.58333333,13.0041667 4.58333333,12.0833333 C4.58333333,11.1625 5.32916667,10.4166667 6.25,10.4166667 C7.17083333,10.4166667 7.91666667,11.1625 7.91666667,12.0833333 L7.91666667,12.0833333 Z"
                    id="Stroke-17"
                  ></path>
                  <path
                    d="M12.9166667,7.08333333 C12.9166667,8.00416667 12.1708333,8.75 11.25,8.75 C10.3291667,8.75 9.58333333,8.00416667 9.58333333,7.08333333 C9.58333333,6.1625 10.3291667,5.41666667 11.25,5.41666667 C12.1708333,5.41666667 12.9166667,6.1625 12.9166667,7.08333333 L12.9166667,7.08333333 Z"
                    id="Stroke-19"
                  ></path>
                  <path
                    d="M18.75,3.75 C18.75,4.67083333 18.0041667,5.41666667 17.0833333,5.41666667 C16.1625,5.41666667 15.4166667,4.67083333 15.4166667,3.75 C15.4166667,2.82916667 16.1625,2.08333333 17.0833333,2.08333333 C18.0041667,2.08333333 18.75,2.82916667 18.75,3.75 L18.75,3.75 Z"
                    id="Stroke-21"
                  ></path>
                  <line
                    x1="6.25"
                    y1="16.25"
                    x2="6.25"
                    y2="15.4166667"
                    id="Stroke-23"
                  ></line>
                  <line
                    x1="11.25"
                    y1="16.25"
                    x2="11.25"
                    y2="10.4166667"
                    id="Stroke-25"
                  ></line>
                  <line
                    x1="17.0833333"
                    y1="16.25"
                    x2="17.0833333"
                    y2="7.08333333"
                    id="Stroke-27"
                  ></line>
                  <line
                    x1="7.5"
                    y1="10.8333333"
                    x2="10"
                    y2="8.33333333"
                    id="Stroke-29"
                  ></line>
                  <line
                    x1="12.9166667"
                    y1="6.25"
                    x2="15.4166667"
                    y2="4.58333333"
                    id="Stroke-31"
                  ></line>
                  <line
                    x1="2.08333333"
                    y1="0.416666667"
                    x2="2.08333333"
                    y2="19.5833333"
                    id="Stroke-14"
                  ></line>
                  <line
                    x1="0.416666667"
                    y1="17.9166667"
                    x2="19.5833333"
                    y2="17.9166667"
                    id="Stroke-16"
                  ></line>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};
